import type {
	Accessibility,
	ActivityType,
	Audience,
	Cost,
	WeatherSuit,
} from '@hewey/shared'

type Meta = { label: string; emoji: string }

export const ACTIVITY_TYPE_META: Record<ActivityType, Meta> = {
	walk: { label: 'Walk', emoji: '🥾' },
	swim: { label: 'Swim', emoji: '🏊' },
	craft: { label: 'Craft', emoji: '🎨' },
	baking: { label: 'Baking', emoji: '🧁' },
	museum: { label: 'Museum', emoji: '🏛️' },
	cinema: { label: 'Cinema', emoji: '🎬' },
	playground: { label: 'Playground', emoji: '🛝' },
	cafe: { label: 'Café', emoji: '☕' },
	restaurant: { label: 'Restaurant', emoji: '🍽️' },
	park: { label: 'Park', emoji: '🌳' },
	shopping: { label: 'Shopping', emoji: '🛍️' },
	day_out: { label: 'Day out', emoji: '🗺️' },
	picnic: { label: 'Picnic', emoji: '🧺' },
	beach: { label: 'Beach', emoji: '🏖️' },
	attraction: { label: 'Attraction', emoji: '🎡' },
	holiday: { label: 'Holiday', emoji: '🧳' },
	other: { label: 'Other', emoji: '✨' },
}

export const WEATHER_SUIT_META: Record<WeatherSuit, Meta> = {
	any: { label: 'Any weather', emoji: '🌈' },
	dry: { label: 'Dry', emoji: '☀️' },
	rainy_ok: { label: 'Rainy OK', emoji: '🌧️' },
	hot: { label: 'Hot day', emoji: '🔥' },
	cold: { label: 'Cold day', emoji: '❄️' },
}

export const AUDIENCE_META: Record<Audience, Meta> = {
	kids: { label: 'Kids', emoji: '🧒' },
	family: { label: 'Family', emoji: '👨‍👩‍👧‍👦' },
	date: { label: 'Date', emoji: '💕' },
	solo: { label: 'Solo', emoji: '🧘' },
}

export const COST_META: Record<Cost, Meta> = {
	free: { label: 'Free', emoji: '🆓' },
	paid: { label: 'Paid', emoji: '💷' },
}

export const ACCESSIBILITY_META: Record<Accessibility, Meta> = {
	pram_friendly: { label: 'Pram-friendly', emoji: '🍼' },
	baby_friendly: { label: 'Baby-friendly', emoji: '👶' },
	toddler_friendly: { label: 'Toddler-friendly', emoji: '🧸' },
	child_friendly: { label: 'Child-friendly', emoji: '🧒' },
}
